import OptionRow from './OptionRow.js';
import StepFrame from './StepFrame.js';

/*
 * ChoiceStep
 *
 * A single-select menu, rendered as a stack of full-width rows.
 *
 * `options` comes from the engine rather than off the node, because an option
 * may be conditional. See Flow.options.
 *
 * CHOOSING ADVANCES IMMEDIATELY. There is no Continue button to press
 * afterwards. With one answer per screen a confirmation step buys nothing and
 * costs a tap on every question in the tree, which over six questions is the
 * difference between a flow that feels quick and one that feels like a form.
 * Back is always there for a misfire.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ChoiceStep = ({
  node,
  onSelect,
  options,
  stepKey
}) => /*#__PURE__*/_jsx(StepFrame, {
  eyebrow: node.eyebrow,
  help: node.help,
  stepKey: stepKey,
  title: node.prompt,
  children: /*#__PURE__*/_jsx("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    },
    children: (options || node.options || []).map((option, index) => /*#__PURE__*/_jsx(OptionRow, {
      help: option.help,
      icon: option.icon,
      label: option.label,
      onClick: onSelect.bind(this, option)
    }, index))
  })
});
export default ChoiceStep;